const mustBeCool = {
  $validator: (value) => {
    if (typeof value !== 'string' || value.length > 200 ) {
      return false;
    }

    return RegExp("^[^\\d!@#$%^&*()_+=\\[\\]{};':\"\\\\|,.<>\\/?`~]+$").test(value);
  },
  // $message: 'test cool'
};

export default mustBeCool;
